import { addDays } from 'date-fns';

import { NormalizedAgents } from '../../../resources/agent/types';
import { DisplayDossiersTodo } from '../../../resources/todo/types';

import { SingleDayTodo } from './SingleDayTodo';

type Props = {
    dossiers: DisplayDossiersTodo;
    agents: NormalizedAgents;
    currentDate: number;
};

export const TomorrowTodo = ({ dossiers, agents, currentDate }: Props): JSX.Element => (
    <SingleDayTodo dossiers={dossiers} agents={agents} date={addDays(currentDate, 1)} />
);
